import Api from 'utils/api'
import { buildUrl } from 'utils/helpers'
import { showInfoMessage, showErrorMessage } from 'store/ui/actions'
import * as actions from './actions'

export const getAdminAddressAccess =
  ({ company_uuid }) =>
  async (dispatch) => {
    dispatch(actions.getAddressAccessRequest())
    try {
      const result = await Api.request(
        buildUrl(`/admin/address_accesses`, { company_uuid })
      )

      dispatch(actions.getAddressAccessSuccess(result))
      return Promise.resolve(result)
    } catch (err) {
      const { error } = await err.json()
      dispatch(actions.getAddressAccessError(error))
      return Promise.reject(err)
    }
  }

export const destroyAdminAddressAccess =
  ({ company_uuid, address_uuids }) =>
  async (dispatch) => {
    try {
      const result = await Api.request(
        `/admin/address_accesses/destroy_batch`,
        {
          method: 'DELETE',
          body: JSON.stringify({ company_uuid, address_uuids }),
        }
      )

      dispatch(showInfoMessage(result?.message))
      dispatch(getAdminAddressAccess({ company_uuid }))
      return Promise.resolve()
    } catch (err) {
      const { error } = await err.json()
      dispatch(showInfoMessage(error))
      return Promise.reject(err)
    }
  }

export const createAddressAccess =
  ({ company_uuid, address_uuids }) =>
  async (dispatch) => {
    try {
      const result = await Api.request(`/admin/address_accesses`, {
        method: 'POST',
        body: JSON.stringify({ company_uuid, address_uuids }),
      })

      dispatch(showInfoMessage(result?.message))
      dispatch(getAdminAddressAccess({ company_uuid }))
      return Promise.resolve()
    } catch (err) {
      const { error } = await err.json()
      dispatch(showInfoMessage(error))
      return Promise.reject(err)
    }
  }
